// extracted by mini-css-extract-plugin
export var base = "_4k-0";
export var updateBanner = "_4k-1";